import TextField from '@mui/material/TextField';
import SimpleDialog from '../../../common/SimpleDialog';
import useChats from '../../hooks/useChats';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

type Props = {
    open: boolean,
    onClose: () => void,    
    onOkay: ()=> void,
    errors: {
        nameError: boolean,
        intentError: boolean
    }
}

const ChatDesignerFlowPropertiesModal = ({ open, onClose, onOkay, errors }: Props) => {
    const { chat, saveChat, updateChatName, updateChatIntent, updateChatFunction, saving } = useChats();

    const onSave = () => {

    }

    const handleClose = () => {
        onClose();
    }

    return (
        <SimpleDialog open={open} onClose={onClose} sx={{ padding: 5 }} size="sm" fullHeight={false}>
            <Box display='flex' flexDirection='column' gap={2}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, rowGap: 2 }} >
                    <Typography variant='h6'>Flow Properties</Typography>

                    <TextField error={errors.nameError} fullWidth name="Name" label="Name" size="small" value={chat.name} onChange={(e) => updateChatName(e.target.value)} sx={{ marginTop: 2 }} />

                    <TextField error={errors.intentError} fullWidth label="Intent" size="small" value={chat.intent} onChange={(e) => updateChatIntent(e.target.value)} sx={{ marginTop: 2 }} />

                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={chat.isFunction} onChange={(e) => updateChatFunction(e.target.checked)} />} label="Function" />                        
                    </FormGroup>
                </Box>
                <Box display='flex' justifyContent='flex-end' gap={2} sx={{ paddingTop: 2 }}>
                    <Button size='small' variant='contained' onClick={handleClose}>Cancel</Button>
                    <Button size='small' variant='contained' onClick={onOkay}>Okay</Button>
                </Box>
            </Box>
        </SimpleDialog >
    )
}

export default ChatDesignerFlowPropertiesModal;